import { motion } from "framer-motion";
import { Reveal, SectionHead } from "./Reveal";
import { GUIDE_IMG } from "../constants/site";

const VALUES = ["Foi", "Droiture", "Travail", "Service"];

export const Founder = () => (
  <section id="guide" data-testid="guide-section" className="bg-ice py-20 lg:py-28">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-4 sm:px-8 lg:grid-cols-12 lg:px-16">
      <Reveal className="lg:col-span-5">
        <motion.div whileHover={{ rotate: 0 }} initial={{ rotate: -2 }} transition={{ duration: 0.6 }} className="relative mx-auto max-w-sm">
          <div className="absolute -inset-4 border border-gold" />
          <div className="absolute -inset-8 border border-gold/30" />
          <div className="relative aspect-[4/5] overflow-hidden bg-royal">
            <img src={GUIDE_IMG} alt="Notre guide" data-testid="guide-image" className="h-full w-full object-cover object-top" />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-navy px-5 py-3 text-white shadow-xl">
            <p className="eyebrow text-gold">Hommage</p>
            <p className="font-display text-sm font-semibold">Notre guide</p>
          </div>
        </motion.div>
      </Reveal>

      <div className="lg:col-span-7 lg:pl-8">
        <SectionHead eyebrow="04 — Notre guide" title="Une maison placée sous la lumière de son guide." />
        <Reveal delay={0.1}>
          <blockquote className="mt-8 border-l-2 border-gold pl-6 font-serif text-xl italic leading-relaxed text-navy sm:text-2xl" data-testid="guide-quote">
            « Le commerce est un dépôt de confiance. Celui qui sert avec droiture ne perd jamais son client. »
          </blockquote>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-base leading-relaxed text-slate-600">
            IBM Ibn Bachir Multimédia s'inspire de l'enseignement de son guide spirituel, homme de foi et de rigueur, dont le sourire et la droiture éclairent notre manière de travailler. C'est dans cet esprit — servir avant de vendre, transmettre avant de posséder — que l'entreprise accompagne commerçants, écoles, cabinets et administrations dans leur équipement informatique et la conception de leurs logiciels de gestion.
          </p>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            Chaque commande honorée, chaque logiciel livré prolonge cette voie : un travail bien fait, un prix juste et une présence durable auprès de ceux qui nous font confiance.
          </p>
        </Reveal>
        <Reveal delay={0.2} className="mt-10 grid grid-cols-2 gap-px bg-navy/10 sm:grid-cols-4">
          {VALUES.map((v, i) => (
            <div key={v} className="bg-ice p-5" data-testid={`guide-value-${i}`}>
              <span className="font-mono text-xs text-gold">0{i + 1}</span>
              <p className="mt-2 font-display font-semibold text-navy">{v}</p>
            </div>
          ))}
        </Reveal>
      </div>
    </div>
  </section>
);
